import { Injectable } from "@angular/core";
import { EasBuilderField } from "@fry/components/common/form-builder/builder.interfaces";
import { AllowedFilters, SearchFilter } from "@fry/lib/list";
import { isEqual, pickBy } from "lodash";
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, tap } from "rxjs";


@Injectable()
export class FilterTableService {

    private _innerSearchFilter$ = new BehaviorSubject<SearchFilter | null>(null);
    public innerSearchFilter$ = this._innerSearchFilter$.asObservable();

    private _normalSearchFilter$ = new BehaviorSubject<SearchFilter | null>(null);
    private _featuredSearchFilter$ = new BehaviorSubject<SearchFilter | null>(null);
    private _quickSearchFilter$ = new BehaviorSubject<SearchFilter | null>(null);


    public searchFilter$ = combineLatest([
        this._normalSearchFilter$.asObservable(),
        this._featuredSearchFilter$.asObservable(),
        this._quickSearchFilter$.asObservable(),
    ]).pipe(
        map(([normalSearch, featuredSearch, quickSearch]) => {
            return {
                ...(normalSearch || null),
                ...(featuredSearch || null),
                ...(quickSearch || null),
            };

        }),
        tap(fltr => console.log('SF: Before emit', fltr)),
        distinctUntilChanged(isEqual),
        tap(fltr => console.log('SF: After emit', fltr)),
        tap(fltr => this.initialFilter = fltr)
    )


    public availableFilters: EasBuilderField[] = [];

    private _innerVisibleFilters$ = new BehaviorSubject<EasBuilderField[]>([]);
    public innerVisibleFilters$ = this._innerVisibleFilters$.asObservable();

    private _visibleFilters$ = new BehaviorSubject<EasBuilderField[]>([]);
    public visibleFilters$ = this._visibleFilters$.asObservable();

    public initialFilter: SearchFilter | undefined;
    public featuredInitialFilter: SearchFilter | undefined;
    public quickInitialFilter: SearchFilter | undefined;

    public filterCount$ = this._normalSearchFilter$.asObservable().pipe(
        map(filter => {
            if (filter === null) {
                return 0;
            } else {
                return Object.keys(filter).length
            }
        })
    );

    constructor(
    ) {
    }

    initialize(availableFilters: AllowedFilters, filter: SearchFilter) {
        this.availableFilters = availableFilters.normal;
        const normalFltIds = this.availableFilters.map(itm => itm.id);
        const featuredFltIds = availableFilters.featured.map(itm => itm.id);
        const quickFltIds = availableFilters.quick.map(itm => itm.id);


        const normalFilter = pickBy(filter, (_, key) => {
            return normalFltIds.includes(key);
        });
        console.log('Normal filters', normalFilter);

        const featuredFilter = pickBy(filter, (_, key) => {
            return featuredFltIds.includes(key);
        });
        console.log('Featured filters', featuredFilter);

        const quickFilter = pickBy(filter, (_, key) => {
            return quickFltIds.includes(key);
        });
        console.log('Quick filters', quickFilter);

        this.initialFilter = normalFilter;
        this.featuredInitialFilter = featuredFilter;
        this.quickInitialFilter = quickFilter;
        this._normalSearchFilter$.next(normalFilter);
        this._featuredSearchFilter$.next(featuredFilter);
        this._quickSearchFilter$.next(quickFilter);
        // this.setupFilter(filter);
    }

    setInnerFilter(filter: SearchFilter) {
        this._innerSearchFilter$.next(filter);
    }

    setupFilter(filter: SearchFilter) {
        const visibleFilters: EasBuilderField[] = [];
        Object.keys(filter).forEach(key => {
            const fltr = this.availableFilters.find(itm => itm.id === key);
            if (fltr !== undefined) {
                visibleFilters.push(fltr);
            }
        })
        this._innerVisibleFilters$.next(visibleFilters);
        this._visibleFilters$.next(visibleFilters);
    }

    addFilter(filter: EasBuilderField) {
        const visibleFilters = this._innerVisibleFilters$.value;
        visibleFilters.push(filter);
        this._innerVisibleFilters$.next(visibleFilters);
    }

    removeFilter(filterId: string) {
        const visibleFilters = this._innerVisibleFilters$.value;
        const idx = visibleFilters.findIndex(fltr => {
            return fltr.id === filterId;
        })
        if (idx > -1) {
            visibleFilters.splice(idx, 1);
            this._innerVisibleFilters$.next(visibleFilters);
        }
    }

    clearFilters() {
        this._innerVisibleFilters$.next([]);
        this.applyNormalFilters({});
    }

    applyQuickFilters(filters: SearchFilter) {
        this._quickSearchFilter$.next(filters);
    }

    applyFeaturedFilters(filters: SearchFilter) {
        this._featuredSearchFilter$.next(filters);
    }

    applyNormalFilters(filters: SearchFilter) {
        this._normalSearchFilter$.next(filters);
        // this._visibleFilters$.next(this._innerVisibleFilters$.value);
    }

    isFilterVisible(fiterId: string): boolean {
        return this._innerVisibleFilters$.value.some(fltr => {
            return fltr.id === fiterId;
        })
    }
}
